import React from 'react'

import { Field } from 'formik'
import TextArea from 'components/Forms/FormElements/TextArea'

const EventFormInspectionNoticesModule = ({ label }) => {
    return (
        <Field
            type="text"
            name="inspectionNotices"
            label={label}
            component={TextArea}
            rows={2}
            minRows={2}
            maxRows={15}
            maxLength={5000}
            autoSize
        />
    )
}

export default EventFormInspectionNoticesModule
